// extracted by mini-css-extract-plugin
export var quantityInput = "_g2-0";